@if (iconDefinition(); as definition) {
  <svg
    class="d-block"
    [attr.viewBox]="definition.viewBox"
  >
    @for (path of definition.paths; track $index) {
      <path
        [attr.d]="path.d"
        [attr.transform]="path.transform ?? null"
        [attr.fill-rule]="path.fillRule ?? null"
        [attr.clip-rule]="path.clipRule ?? null"
        [attr.stroke-width]="path.strokeWidth ?? null"
        [attr.stroke-linecap]="path.strokeLinecap ?? null"
        [attr.stroke-linejoin]="path.strokeLinejoin ?? null"
        [attr.fill]="path.fill ?? 'currentColor'"
        [attr.stroke]="path.stroke ?? 'currentColor'"
        [attr.fill-opacity]="fillOpacity()"
        [attr.stroke-opacity]="strokeOpacity()"
      />
    }
  </svg>
}
